// extracted by mini-css-extract-plugin
export default {"tw-rank":"treadwell-rank-banner__tw-rank___2SGzY","tw-text-flag":"treadwell-rank-banner__tw-text-flag___1NqW2","icon":"treadwell-rank-banner__icon___1GNaq"};